// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3OCIo","paramInput":"JobSimulator_paramInput__3B-Zy","input":"JobSimulator_input__e63dG"};